<div
  class="layout-component"
  [style]="{maxWidth: width}">
    <div
      #inner
      class="layout-modal"
      style="{{modalStyles}}"
      (mousedown)="preventAction($event)"
    >
      <ng-content></ng-content>
    </div>
</div>

